import { api } from '@/lib/api'
import type { APIResponse } from '@/types/api'

export interface NextCodes {
	hourType: string
	project: string
	user: string
}

export class NextCodesService {
	static async getNextCodes(companyID: string): Promise<NextCodes> {
		const response = await api.get<APIResponse<NextCodes>>('/next-codes', {
			params: { companyID },
		})
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al obtener los próximos códigos')
		}

		return apiResponse.data
	}
}
